module.exports = __webpack_public_path__ + "img/deleteBg.3629daab.png";